export default "__VITE_ASSET__CsAsnP6S__"